import _typeof from "@babel/runtime/helpers/esm/typeof";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { MSG_CENTRAL_STORAGE_KEY } from "../constants";
import { MsgContext } from "./msgContext";
import { getStorage } from "../utils/storage-utils";
import { EventSourcePolyfill } from 'event-source-polyfill';
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
//保存在localStorage中的信息
var storageMsgCentral = getStorage(MSG_CENTRAL_STORAGE_KEY);
var MsgProvider = function MsgProvider(props) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    refresh = _useState2[0],
    setRefresh = _useState2[1];

  //请求头token
  var token = props.token || (storageMsgCentral === null || storageMsgCentral === void 0 ? void 0 : storageMsgCentral.token);
  //当前使用环境
  var env = props.env || (storageMsgCentral === null || storageMsgCentral === void 0 ? void 0 : storageMsgCentral.env);

  //触发刷新
  var triggerRefresh = function triggerRefresh() {
    setRefresh(function (prevState) {
      return prevState + 1;
    });
  };

  //已读未读数量
  var _useState3 = useState({
      read: 0,
      unread: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    count = _useState4[0],
    setCount = _useState4[1];
  var _setCount = function _setCount(_ref) {
    var read = _ref.read,
      unread = _ref.unread;
    setCount(function (prevState) {
      return {
        read: typeof read === 'undefined' ? prevState.read : read,
        unread: typeof unread === 'undefined' ? prevState.unread : unread
      };
    });
  };

  //建立sse连接
  useEffect(function () {
    if (props.notConnect) {
      return;
    }
    if (typeof EventSource !== 'undefined' && token) {
      // const uuid = `U${moment(new Date()).format('YYYYMMDDHHmmss')}`;
      var uuid = uuidv4(); //36位
      var prefix = 'https://api.dev.sayweee.net';
      switch (env) {
        case 'prod':
          prefix = 'https://api.sayweee.net';
          break;
        case 'tb1':
          prefix = 'https://api.tb1.sayweee.net';
          break;
      }
      var source = new EventSourcePolyfill("".concat(prefix, "/message/ims/sse?uuid=").concat(uuid), {
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      //NOTE EventSourcePolyfill消息数据不能被浏览器EventStream截取，故在控制台打印来查看是否有新数据
      source.onmessage = function (e) {
        try {
          var res = JSON.parse(e.data);
          if (_typeof(res) === 'object') {
            //REMINDER-新消息 REVOKE-撤回 HEART_BEAT-心跳
            if (res.type === 'REMINDER' || res.type === 'REVOKE') {
              console.log('===EventStream data===', res);
              triggerRefresh();
            } else {
              return;
            }
          }
        } catch (e) {}
      };
      return function () {
        source.close();
      };
    } else {
      console.error('抱歉，你的浏览器不支持 server-sent 事件...');
    }
  }, []);
  return /*#__PURE__*/React.createElement(MsgContext.Provider, {
    value: {
      refresh: refresh,
      triggerRefresh: triggerRefresh,
      token: token,
      env: env,
      count: count,
      _setCount: _setCount
    }
  }, props.children);
};
export default MsgProvider;